export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/analytics/uncovered-areas', 'admin.uncovered-areas')

    .within('admin')

    .segment('uncovered-areas', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.analytics'
      }],
      template: '<admin-uncovered-areas-page></admin-uncovered-areas-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-uncovered-areas.module" */ "./uncovered-areas/admin-uncovered-areas.module");
      }
    });
}
